import { useMaintenanceStore } from '@/stores/helpers/maintenance.js'

export const handleMaintenance = () => {
  useMaintenanceStore().setMaintenanceMode(true)

  if (window.location.pathname.startsWith('/maintenance') === false) {
    const redirectPath = encodeURIComponent(window.location.pathname + window.location.search)
    window.location.href = `/maintenance?redirect=${redirectPath}`
  }
}
